import { render } from "./info-staff.vue?vue&type=template&id=1701b1c6&scoped=true&ts=true"
import script from "./info-staff.vue?vue&type=script&lang=ts"
export * from "./info-staff.vue?vue&type=script&lang=ts"

import "./info-staff.vue?vue&type=style&index=0&id=1701b1c6&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1701b1c6"]])

export default __exports__